import { jsxs as o, jsx as l } from "react/jsx-runtime";
const n = ({ size: t = 24, ...i }) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    ...i,
    children: [
      /* @__PURE__ */ l("path", { d: "M0 0H24V24H0V0Z", fill: "#FFCF5C" }),
      /* @__PURE__ */ l("path", { d: "M0 0H24V8H0V0Z", fill: "black" }),
      /* @__PURE__ */ l("path", { d: "M0 8H24V16H0V8Z", fill: "#B73C24" })
    ]
  }
);
export {
  n as RegionGermanIcon
};
